import React from 'react';
import { Euler, Vector3 } from '@react-three/fiber';
import { useGLTF } from '@react-three/drei';

import { Flavor } from '../../../types';
import { GLTFResult } from './types';
import { glass, cider, cap, label } from './materials';
import useBackTexture from './useBackTexture';
import useFrontTexture from './useFrontTexture';
import useTopTexture from './useTopTexture';
import useCiderColor from './useCiderColor';

const path = "/static/glb/cider-low.glb";

const Cider = ({
  flavor,
  position = [0, 0, 0],
  scale = 1,
  rotation = [0, 0, 0]
}: {
  flavor: Flavor,
  position?: Vector3,
  scale?: number,
  rotation?: Euler
}) => {

  const { nodes } = useGLTF(path) as any as GLTFResult;

  useBackTexture(flavor);
  useFrontTexture(flavor);
  useTopTexture(flavor);

  useCiderColor(flavor);

  return (
    <group
      position={position}
      scale={[scale, scale, scale]}
      rotation={rotation}
    >
      <mesh geometry={nodes.Front.geometry} material={label.front.outer} />
      <mesh geometry={nodes.Front_Backside.geometry} material={label.front.inner} />

      <mesh geometry={nodes.Cider.geometry} material={cider} />
      <mesh geometry={nodes.Bottle.geometry} material={glass} />
      <mesh geometry={nodes.Cap.geometry} material={cap} />
      <mesh geometry={nodes.Back.geometry} material={label.back} />



      <mesh geometry={nodes.Top.geometry} material={label.top.outer} />
      <mesh geometry={nodes.Top_Backside.geometry} material={label.top.inner} />
    </group>
  );
}

useGLTF.preload('/cider-low.glb');

export default Cider;